module.exports = __webpack_public_path__ + "img/img-5.f7155ba2.webp";